import React from "react";
import {Route, Switch} from "react-router-dom";

import asyncComponent from "util/asyncComponent";
import MayorDashboardRoutes from "./mayorDashboard/index";
import ClientDashboardRoutes from "./clientDashboard/index";
import AdminDashboardRoutes from './adminDashboard/index';

const App = ({match}) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}clientDashboard`} component={ClientDashboardRoutes}/>
      <Route path={`${match.url}adminDashboard`} component={AdminDashboardRoutes}/>
      <Route path={`${match.url}mayorDashboard`} component={MayorDashboardRoutes}/>
    </Switch>
  </div>
);

export default App;
